/* The Edge Gift Concierge — orchestration + capture (Sprint 4.2 Track A).
   Dependency-free. Degrades gracefully if Klaviyo isn't configured.
   Config is injected by sections/gift-concierge-controller.liquid as window.EdgeConcierge. */
(function () {
  'use strict';
  var CFG = window.EdgeConcierge || {};
  if (!CFG.enabled) return;

  var LS = {
    get: function (k) { try { return JSON.parse(localStorage.getItem(k)); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };
  var KEY_DISMISS = 'edge_gc_dismissed_at';
  var KEY_SUB = 'edge_gc_subscribed';
  var KEY_PROFILE = 'edge_gc_profile';
  var SESSION_SHOWN = false;

  var profile = LS.get(KEY_PROFILE) || {};

  // ---- Klaviyo (optional) ----
  function loadKlaviyo() {
    if (!CFG.klaviyoKey || window.klaviyo) return;
    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=' + encodeURIComponent(CFG.klaviyoKey);
    document.head.appendChild(s);
  }
  function klaviyoIdentify(props) {
    if (!CFG.klaviyoKey) return;
    try { (window.klaviyo = window.klaviyo || []).push(['identify', props]); } catch (e) {}
  }
  function klaviyoTrack(event, props) {
    if (!CFG.klaviyoKey) return;
    try { (window.klaviyo = window.klaviyo || []).push(['track', event, props || {}]); } catch (e) {}
  }
  // Mirror to the Edge measurement layer (GA4/Clarity) — independent of Klaviyo.
  function ga(name, props) { try { if (window.EdgeTrack) window.EdgeTrack.event(name, props || {}); } catch (e) {} }

  // ---- DOM helpers ----
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  var modal = $('#edge-gc');
  if (!modal) return;
  var steps = $all('.edge-gc__step', modal);
  var dots = $all('.edge-gc__dot', modal);
  var current = 0;

  function showStep(i) {
    current = i;
    steps.forEach(function (s, idx) { s.classList.toggle('is-active', idx === i); });
    dots.forEach(function (d, idx) { d.classList.toggle('is-on', idx <= i); });
    var focusable = steps[i] && steps[i].querySelector('button,input,a');
    if (focusable && i > 0) { try { focusable.focus({ preventScroll: true }); } catch (e) {} }
  }

  function openModal(trigger) {
    if (SESSION_SHOWN) return;
    SESSION_SHOWN = true;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    showStep(0);
    klaviyoTrack('Viewed Gift Concierge', { trigger: trigger || 'auto' });
    ga('concierge_open', { trigger: trigger || 'auto' });
  }
  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    LS.set(KEY_DISMISS, Date.now());
    ga('concierge_dismiss', { step: current });
  }

  // ---- Step wiring ----
  // Step 0: shopping_for
  $all('[data-gc-shopping]', modal).forEach(function (btn) {
    btn.addEventListener('click', function () {
      profile.shopping_for = btn.getAttribute('data-gc-shopping');
      LS.set(KEY_PROFILE, profile);
      klaviyoTrack('Started Gift Concierge', { shopping_for: profile.shopping_for });
      ga('concierge_shopping_for', { shopping_for: profile.shopping_for });
      try { if (window.EdgeAttribution) window.EdgeAttribution.setGiftSelf(profile.shopping_for); } catch (e) {}
      // self-shoppers skip the occasion step
      if (profile.shopping_for === 'self') { buildEdit(); showStep(2); }
      else { showStep(1); }
    });
  });
  // Step 1: occasion
  $all('[data-gc-occasion]', modal).forEach(function (btn) {
    btn.addEventListener('click', function () {
      profile.occasion = btn.getAttribute('data-gc-occasion');
      LS.set(KEY_PROFILE, profile);
      klaviyoTrack('Selected Occasion', { occasion: profile.occasion });
      ga('concierge_occasion', { occasion: profile.occasion });
      buildEdit();
      showStep(2);
    });
  });

  // Step 2: the curated edit CTA (value before the ask)
  function buildEdit() {
    var url = CFG.editUrl || '/collections/all';
    var params = [];
    if (profile.shopping_for) params.push('shopping_for=' + encodeURIComponent(profile.shopping_for));
    if (profile.occasion) params.push('occasion=' + encodeURIComponent(profile.occasion));
    var full = url + (params.length ? (url.indexOf('?') > -1 ? '&' : '?') + params.join('&') : '');
    var link = $('#edge-gc-edit-link', modal);
    if (link) link.setAttribute('href', full);
  }

  // Step 2/3: email capture
  var emailForm = $('#edge-gc-email-form', modal);
  if (emailForm) {
    emailForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = ($('#edge-gc-email', modal) || {}).value;
      if (!email) return;
      profile.email = email;
      LS.set(KEY_PROFILE, profile);
      LS.set(KEY_SUB, true);
      var props = {
        $email: email,
        shopping_for: profile.shopping_for || '',
        occasion_interest: profile.occasion ? [profile.occasion] : [],
        capture_source: 'gift_concierge'
      };
      // Attach the acquisition story so first-touch rides on the Klaviyo profile for life.
      try { if (window.EdgeAttribution) { var att = window.EdgeAttribution.toKlaviyo(); for (var k in att) { if (att[k]) props[k] = att[k]; } } } catch (e) {}
      klaviyoIdentify(props);
      klaviyoTrack('Subscribed', { source: 'gift_concierge', shopping_for: profile.shopping_for, occasion: profile.occasion });
      ga('concierge_signup', { shopping_for: profile.shopping_for || '', occasion: profile.occasion || '' });
      ga('newsletter_signup', { source: 'gift_concierge' });
      // gift-buyers get the optional reminder step; self-shoppers go straight to success
      if (profile.shopping_for === 'self') { showStep(4); }
      else { showStep(3); }
    });
  }

  // Step 3: optional reminder (recipient name + date)
  var remForm = $('#edge-gc-reminder-form', modal);
  if (remForm) {
    remForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var name = ($('#edge-gc-recipient', modal) || {}).value || '';
      var date = ($('#edge-gc-date', modal) || {}).value || '';
      profile.recipient_name = name;
      profile.reminder_date = date;
      profile.accepts_gift_reminders = true;
      LS.set(KEY_PROFILE, profile);
      klaviyoIdentify({ accepts_gift_reminders: true });
      klaviyoTrack('Saved Gift Reminder', {
        recipient_name: name, occasion: profile.occasion || '', reminder_date: date
      });
      ga('concierge_reminder_set', { occasion: profile.occasion || '', has_date: date ? 'yes' : 'no' });
      showStep(4);
    });
  }
  var skipBtn = $('#edge-gc-skip-reminder', modal);
  if (skipBtn) skipBtn.addEventListener('click', function () { showStep(4); });

  // close handlers
  $all('[data-gc-close]', modal).forEach(function (el) { el.addEventListener('click', closeModal); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal(); });

  // ---- Trigger orchestration: at most ONE invitation per session ----
  function alreadyEngaged() {
    if (LS.get(KEY_SUB)) return true;
    var d = LS.get(KEY_DISMISS);
    if (d && (Date.now() - d) < (CFG.cooldownDays || 14) * 864e5) return true;
    return false;
  }
  function pageAllowed() {
    var t = (CFG.template || '').toLowerCase();
    if (t.indexOf('index') === 0 && CFG.onHomepage) return true;
    if (t.indexOf('collection') === 0 && CFG.onCollection) return true;
    return false;
  }

  if (!alreadyEngaged()) {
    var armed = false;
    function armInvitation() {
      if (armed || !pageAllowed()) return;
      armed = true;
      var fired = false;
      function fire(trigger) { if (fired) return; fired = true; openModal(trigger); }
      // time
      setTimeout(function () { fire('time'); }, (CFG.delaySeconds || 8) * 1000);
      // scroll
      var sp = (CFG.scrollPercent || 30) / 100;
      window.addEventListener('scroll', function onScroll() {
        var h = document.documentElement;
        var pct = (h.scrollTop || document.body.scrollTop) / ((h.scrollHeight - h.clientHeight) || 1);
        if (pct >= sp) { window.removeEventListener('scroll', onScroll); fire('scroll'); }
      }, { passive: true });
    }
    armInvitation();

    // exit intent (desktop: mouse-leave; mobile: fast scroll-up near top)
    if (CFG.exitIntent) {
      document.addEventListener('mouseout', function (e) {
        if (!e.relatedTarget && e.clientY <= 0) openModal('exit');
      });
      var lastY = window.pageYOffset;
      window.addEventListener('scroll', function () {
        var y = window.pageYOffset;
        if (y < lastY - 12 && y < 240) openModal('exit-mobile');
        lastY = y;
      }, { passive: true });
    }
  }

  // ---- Footer "gifting circle" ----
  var footer = $('#edge-gc-footer');
  if (footer) {
    var ff = $('.edge-gc-footer__form', footer);
    if (LS.get(KEY_SUB)) footer.classList.add('is-done');
    if (ff) ff.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (ff.querySelector('input[type=email]') || {}).value;
      if (!email) return;
      klaviyoIdentify({ $email: email, capture_source: 'footer' });
      klaviyoTrack('Subscribed', { source: 'footer' });
      ga('newsletter_signup', { source: 'footer_gifting_circle' });
      LS.set(KEY_SUB, true);
      footer.classList.add('is-done');
    });
  }

  loadKlaviyo();
})();
